import { createFileRoute } from "@tanstack/react-router";

import VoiceAdmin from "@/components/VoiceAdmin";

// Passthrough, same shape as every other admin route (see file-uploads.tsx): the console
// component owns everything, admin/route.tsx owns the shell and the gate.
export const Route = createFileRoute("/admin/voice")({
  component: VoiceAdmin,
});
